const locale: Locale = {
  ko: {
    about: '이용 안내',
    slogan: '학생이 물으면, 학교가 답한다!',
    aboutDesc:
      '지스트 청원은 학생들이 학교운영과 관련된 의견을 공유하고, 이에 대한 요구를 학교 측에 제시하여 직접 답변을 받을 수 있는 서비스입니다. ',

    develop1: '지스트 청원의 개발은 ',
    Infoteam: 'Infoteam',
    develop2: '이 맡고 있고, ',

    manage1: '게시판 운영은 ',
    graduate: '지스트 대학원총학생회',
    and: '와 ',
    emc: '비상대책위원회 소통국',
    manage2: '에서 관리하고 있습니다. ',
    purpose: '지스트 청원은 학생과 학교 간의 원활한 소통을 지향합니다.',

    process: '지스트 청원은 다음 과정으로 진행됩니다.',
    step1: '청원하기',
    step2: '사전동의',
    step3: '청원진행',
    step4: '청원답변',

    content1:
      '지스트 구성원 누구라도 지스트 이메일(gist.ac.kr 혹은 gm.gist.ac.kr)로 \
    회원가입을 하여 직접 청원글을 작성하실 수 있습니다. \
    청원을 작성하기 이전에 지스트 청원 게시판 운영 원칙과 청원 작성 요령 안내를 확인하신 뒤, \
    이에 유의하여 청원에 참여해주시길 바랍니다.',

    content2:
      '청원이 진행되기 앞서 사전동의 단계를 거칩니다. \
      지스트 청원은 부적절한 청원의 노출을 최소화하고, \
      지스트 구성원들의 목소리를 효율적으로 청원 페이지에 담아내고자 \
      사전동의 절차를 운영합니다. 작성된 청원은 5개 이상의 동의를 받으면, \
      관리자의 승인을 거쳐 모든 청원 페이지에 게시됩니다. \
      주변 지인들에게 청원 게시글 링크를 공유하여 사전 동의를 받길 바랍니다.',
    content3:
      '승인된 청원은 모든 청원 페이지에 공개되어 누구나 열람할 수 있으며, \
      모든 지스트 구성원은 청원 동의에 참여할 수 있습니다. 한 번 청원동의에 참여한다면, \
      동의 철회 및 내용 수정이 불가합니다. 이에 유의하여 신중히 참여해주시길 바랍니다.',
    content4:
      '50명 이상의 청원동의를 받은 청원은 원내 관련 부서에서 2주 이내 답변합니다. \
      청원에 대한 답변은 답변된 청원 페이지에 게시됩니다.',
    content5:
      "중복, 비방, 욕설, 혐오 표현, 명예훼손 등 부적절한 청원 내용은 \
    지스트 청원 운영 원칙에 따라 '숨김/삭제' 처리될 수 있습니다. 허위사실을 포함하거나 지스트 \
    구성원 공동의 이익과 관련없는 청원, 타인을 악의적으로 비방하거나 \
    명예를 훼손하기 위한 목적으로 작성된 청원에는 답변이 어려울 수 있습니다.",

    petitionBtn: '청원 바로가기',
    listBtn: '청원 목록 보기',

    matters: '청원 유의사항',
  },
  en: {
    about: 'About GIST Petition',
    slogan: 'A Student Requests, The GIST Responses!',
    aboutDesc:
      'GIST petition is a service that students can share their opinions \
      related to the college policy and request their demands to the college to receive direct answer.',

    develop1: ' ',
    Infoteam: 'Infoteam',
    develop2: ' is in charge of development of the GIST petition, ',

    manage1: ' ',
    graduate: 'GIST Graduate Student Union',
    and: ' and ',
    emc: 'Temporary Student Council ',
    manage2: 'do management of the GIST petition. ',

    purpose:
      'GIST petition aims for amicable communication between students and college.',

    process: 'The GIST petition will proceed to the next step.',
    step1: `Create a\nPetition`,
    step2: 'Prior \nConsent',
    step3: 'Petition \nIn Progress',
    step4: 'Answer a\nPetition',

    content1:
      'You can sign up through the GIST email (gist.ac.kr or gm.gist.ac.kr) and write your own petition. \
    Before filling out the petition, please check the principle of GIST petition \
    and the guide to write a petition, and pay attention to this.',

    content2:
      "Before the petition proceeds, it goes through the step of prior consent. \
      GIST petition adopted this policy to minimize \
      the exposure of inappropriate petitions and efficiently \
      recieve opinions of GIST members. \
      A petition with more than 5 agreements will be posted on 'Browse' page \
      after approval by the administrator. \
      Please get prior consent from your acquaintances through the sharing the petition's URL.",
    content3:
      "Approved petitions are open to 'Browse' page \
      and are accessible to anyone, and all GIST members can agree to the petition. \
      Once you agree to the petition, \
      you cannot withdraw the agreement or modify the contents.\
      Please take this into consideration and participate carefully.",
    content4:
      "The petition with more than 50 agreements, \
      will be answered within two weeks by the related department. \
      Answered petitions will be posted on the 'Answers' page.",

    petitionBtn: 'Start a Petition',
    listBtn: 'Petition List',

    matters: 'Matters That Require Attention',
    content5:
      'Inappropriate petition contents such as duplication, \
      slander, abusive language, hate expression, defamation, etc. \
      could be hidden or deleted in accordance with the principle of GIST petition. \
      It could be difficult to answer petitions \
      that contain misinformation or are not related to the common interests of GIST members, \
      or petitions created for the purpose of maliciously slandering or defaming others.',
  },
}

export default locale
